import React from 'react'
import Icon from './Icon'
// import { UncontrolledTooltip } from 'reactstrap'
import { Sort_array } from './ArticleEdit'

export default class ProviderQueryBadge extends React.PureComponent {
    render() {
        const { className, query, setAmazonSelectorVisible, removeQueryHistory, onClick } = this.props
        return (
            <React.Fragment>
                <span
                    id={'ProviderQueryBadge-' + query.id}
                    className={'badge badge-amazon pointer' + ((className && ' ' + className) || '')}
                    style={{ position: 'relative' }}
                >
                    <span onClick={(e) => onClick(true, query.keywords)}>
                        {query.keywords}
                        {(query.Sort && (
                            <span className="text-light">
                                {' '}
                                {(Sort_array.find((item) => item.value === query.Sort) && (
                                    <Icon name={Sort_array.find((item) => item.value === query.Sort)?.icon} />
                                )) ||
                                    null}{' '}
                            </span>
                        )) ||
                            null}
                        {(query.category && <span className="text-light"> {query.category} </span>) || null}
                    </span>
                    <span onClick={() => removeQueryHistory(query.id)}>
                        <Icon name="close" />
                    </span>
                </span>
                {/* <UncontrolledTooltip target={'ProviderQueryBadge-'+query.id}>
                {query.category}
            </UncontrolledTooltip> */}
            </React.Fragment>
        )
    }
}
